import { render } from "./CardsView.vue?vue&type=template&id=4be85378"
import script from "./CardsView.vue?vue&type=script&lang=js"
export * from "./CardsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__